'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isHTMLElement(value) {
  return typeof value === "object" && value?.nodeType === Node.ELEMENT_NODE && typeof value?.nodeName === "string";
}

exports.isHTMLElement = isHTMLElement;
